module.exports = __webpack_public_path__ + "assets/img/36bdb117d9397f5cd36e9f3f1ad0428f.svg";